// src/utils/warehouseRedirect.js
import {
    ORDERS,
    ORDERS_SHIPPED,
    LOCATIONS,
    BILLING,
    GENERATE_LABELS,
    NATURA_REPLENISHMENTS
} from '../navigation/constants'
import { isSuperAdminUser } from './userUtils'

/**
 * Returns the destination path for a user after selecting a warehouse.
 * Based on the user's roles.
 */
export function getWarehouseRedirectPath(user, warehouseId) {
    if (isSuperAdminUser(user)) {
        return ORDERS.replace(':warehouse_id', warehouseId)
    }
    if (!user?.roles) {
        return ORDERS.replace(':warehouse_id', warehouseId)
    }
    if (user.roles.find((rol) => rol === "ROLE_LAST_MILE_SUPERVISOR") || user.roles.find((rol) => rol === "ROLE_REVERSE_LOGISTICS_OPERATOR")) {
        return ORDERS_SHIPPED.replace(':warehouse_id', warehouseId)
    }
    if (user.roles.find((rol) => rol === "ROLE_INVENTORY_SUPERVISOR")) {
        return LOCATIONS.replace(':warehouse_id', warehouseId)
    }
    if (user.roles.find((rol) => rol === "ROLE_BILLING_CONFIGURATION_EDITOR")) {
        return BILLING.replace(':warehouse_id', warehouseId)
    }
    if (user.roles.length === 1 && user.roles.find((rol) => rol === "ROLE_OPERATOR")) {
        return GENERATE_LABELS.replace(':warehouse_id', warehouseId)
    }
    if (user.roles.length === 1 && user.roles.find((rol) => rol === "ROLE_NATURA_INBOUND")) {
        return NATURA_REPLENISHMENTS.replace(':warehouse_id', warehouseId)
    }
    return ORDERS.replace(':warehouse_id', warehouseId)
}
